import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-mobile-view-dialog',
  templateUrl: './mobile-view-dialog.component.html',
  styleUrls: ['./mobile-view-dialog.component.scss']
})
export class MobileViewDialogComponent {
  config:any;
  constructor(
    public dialogRef: MatDialogRef<MobileViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }
  
  ngAfterContentInit(){
    this.config = this.data;
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
